<template>
  <footer class="footer">
    <div class="container">
      <el-row class="py-4">
        <el-col :span="24">
          <div class="bg-white-1 p-4">
            <div class="footer-col-text pb-4">
              <el-icon class="fs-xxxl" style="vertical-align: text-bottom"
                ><Link
              /></el-icon>
              <span class="text-primary shadow-text fs-xxxl"> 相关链接</span>
            </div>
            <div class="">
              <div
                class="flex-one jc-between inherit-w"
                :style="{
                  'flex-flow': 'wrap',
                  ...wrapperStyle
                }"
              >
                <span
                  :href="item.url"
                  v-for="(item, index) in links"
                  :key="index"
                  target="_blank"
                  class="fs-xl flex-one mb-1"
                  :style="linkStyle"
                >
                  <a
                    :title="item.name"
                    class="text-hover underline-hover cursor-p fs-xl text-dark"
                    :href="item.url"
                    target="_blank"
                  >
                    {{ item.name }}
                    <!-- style="text-decoration: underline" -->
                  </a>
                </span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </footer>
</template>

<script setup>
import { computed, toRaw } from 'vue'
import { Link } from '@element-plus/icons-vue'

import useSize from '@/hooks/useSize.js'

import LogoTitleImg from '@/assets/images/logo-2.png'
import { LINKS } from '@/config/constant.js'

const { xs, w } = useSize()

const links = LINKS

const linkStyle = computed(() => {
  const r = {
    'justify-content': 'flex-start'
  }
  if (xs.value) {
    r.width = '50%'
  }
  if (w.value < 500) {
    r.width = '100%'
  }
  return r
})

const wrapperStyle = computed(() => {
  const r = {}
  if (xs) {
    // r['justify-content'] = 'flex'
  }
  return r
})
</script>

<style lang="scss" scoped>
.footer {
  background: #e5e5e5;
}
</style>
